import { render } from "./client-review-overview.vue?vue&type=template&id=bf32a1c2&ts=true"
import script from "./client-review-overview.ts?vue&type=script&lang=ts&external"
export * from "./client-review-overview.ts?vue&type=script&lang=ts&external"

import "./client-review-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__